import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { CreateSentinelInput } from "../../../__generated__/globalTypes";
import {
  CreateSentinelMutation,
  CreateSentinelMutationVariables,
} from "../../../__generated__/CreateSentinelMutation";
import { CREATE_SENTINEL } from "../sentinels.queries";
import { parseParams } from "../../../helpers/clean-object";
import { toast } from "react-toastify";

interface IProps {
  defaultValues: DeepPartial<CreateSentinelInput>;
  onCompleted: () => any;
}

export const useCreateSentinel = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateSentinelInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateSentinelMutation,
    CreateSentinelMutationVariables
  >(CREATE_SENTINEL);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createSentinel?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createSentinel?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
      toast.error(
        "Une Erreur est survenue lors de la création de la sentinelle"
      );
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
